import React, { Component,useState, useEffect } from 'react'
import HealingComplete from '../../HealingComplete/HealingComplete'

import AppLayout from "../AppLayout/AppLayout";

import BreadCrumbExtension, { IBreadCrumbExtension } from '../../Controls/BreadCrumbExtension/BreadCrumbExtension'

const breadcrumbItem: IBreadCrumbExtension[] = [
  { text: 'Self-Healing Tool', key: 'Home', href: '/' },
  { text: 'Broken Link', key: 'ACAA' },
  { text: 'Content Changes Review', key: 'f5' },
];

export default class HealingCompletePage extends Component {
  render() {
    document.title = 'Content Changes Review' + " | " + "Microsoft Digital Asset Self-Healing Tool";
    return (
      <AppLayout
        renderBreadcrumb={() =>
          null
        }
        renderContentPane={() => <HealingComplete />} />
    );
  }
}